import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import SiblingInfoTable from '../SiblingInfoTable';
import { useStyles } from './style';

interface SiblingDetail {
  name: string;
  gender: string;
  dateOfBirth: string;
  level: string;
}

interface SiblingDetailsProps {
  siblingDetails: SiblingDetail[];
  examType: string;
}

const SiblingDetails = (props: SiblingDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { siblingDetails, examType } = props;

  return (
    <Box className={classes.siblingContainer}>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <Typography variant="h3" className={classes.tableTitle}>
            {t('exam->>NonNationalExam.SiblingInfo')}
          </Typography>
          <KeyValue
            keyText={t('exam->>NonNationalExam.IsSiblingRegistering', { examType })}
            valueText={
              siblingDetails.length
                ? t('exam->>NonNationalExam.Yes')
                : t('exam->>NonNationalExam.No')
            }
            capitalize={false}
          />
        </Grid>
      </Grid>
      {siblingDetails.length > 0 && <SiblingInfoTable isShowAction={false} data={siblingDetails} />}
    </Box>
  );
};
export default SiblingDetails;
